import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index.js'
import routes from './routeList.js'
import { getLocal, setLocal, setJsapiSign, getApplicationInfo, getAKey } from '../utils/index'
import { clientTYPE } from '../utils/constant.js'
import { delCookie } from '../utils/index.js'

Vue.use(Router)

Vue.prototype.$clientTYPE = clientTYPE
const router = new Router(routes)
router.beforeEach((to, from, next) => {
  const lat = getLocal('lat')
  const lng = getLocal('lng')
  /* 调用公众号 菜单配置（主要是包月方案） */
  if ((to.path !== '/notice1') && (to.path !== '/scanQRCodeFailed') && (to.path !== '/newNotice') && (to.path !== '/goldPlanResults') && (to.path !== '/privacyPolicyHistory')) { // 如果是须知页面,扫码失败页面不调用该接口   防止页面弹窗报错找不到用户信息
    store.dispatch('commitMenuCofig')
  }

  document.title = to.meta.name || getLocal('appName') || ''
  if (from.name == 'orderDeduction') {
    window.location.reload()
  }
  if (to.query.reqJson && to.path !== '/scanQRCodeFailed' && to.path !== '/notice1' && (to.path !== '/newNotice') && (to.path !== '/goldPlanResults') && (to.path !== '/privacyPolicyHistory')) {
    const param = JSON.parse(to.query.reqJson)
    /* 当dealerId变化清除登录信息 */
    if (localStorage.getItem('driverDealerId') != param.driverDealerId) {
      delCookie('token')
      delCookie('refreshToken')
    }
    /* 清除原有app信息 */
    localStorage.clear()
    /* 链接必填参数重新赋值 */
    lat ? setLocal('lat', lat) : ''
    lng ? setLocal('lng', lng) : ''
    for (const key in param) {
      setLocal(key, param[key])
    }
  }

  // /* 请求类型为微信公众号时，加载微信公众号的sdk文件 */
  if (localStorage.getItem('clientType') == clientTYPE.WX) {
    setJsapiSign(store)
  }

  if (store.getters.appName === '' && localStorage.getItem('clientType') != clientTYPE.APP && localStorage.getItem('clientType')) { // 是否有APP信息 app内嵌须知页面等不需要
    // 判断是否是扫码领劵失败页面  不是扫码领券失败页面才会获取应用基础信息   防止页面报错
    if ((to.name !== 'scanQRCodeFailed') && (to.path !== '/privacyPolicyHistory')) {
      getApplicationInfo().then(resp => {
        store.commit('setAppInfo', resp.data)
        setLocal('appName', resp.data.appName)
        setLocal('appid', resp.data.appId)
        if (!to.meta.name) {
          document.title = resp.data.appName
        }
      })
    }
  }
  if (store.getters.ak === '' && (localStorage.getItem('clientType') === clientTYPE.WX || localStorage.getItem('clientType') === clientTYPE.ALI)) { // 是否有ak信息& 是公众号或生活号
    getAKey().then(resp => {
      store.commit('setAKey', resp.data)
      setLocal('ak', resp.data.ak)
    }).finally(() => {
      next()
    })
  } else {
    next()
  }
})
export default router

